<template>
  <div class="input-boolean" :class="{ selected: input_value }">
    <input id="input-checkbox" v-model="input_value" type="checkbox" />
    <label for="input-checkbox" v-if="label != ''">{{ label }}</label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  label: string
  modelValue: boolean
}>()

const input_value = computed({
  get: () => {
    return props.modelValue
  },
  set: (v: boolean): void => {
    emits('update:modelValue', v)
  }
})

function on_click() {
  input_value.value = !input_value.value
}

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()
</script>

<style scoped lang="scss">
@import '@/assets/mixins.scss';
.input-boolean {
  padding: 10px 20px;
  border-radius: 100px;
  display: flex;
  gap: 10px;
  background-color: var(--vc-white);
  border: 1px solid var(--vc-gray2);
}

.input-boolean.selected {
  background-color: var(--vc-primary);
  border: 1px solid transparent;
  color: white;
}

.input-boolean > label {
  user-select: none;
  cursor: pointer;
  width: 100%;
}
</style>
